import { render, staticRenderFns } from "./Nomad.vue?vue&type=template&id=345af93c&"
import script from "./Nomad.vue?vue&type=script&lang=js&"
export * from "./Nomad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports